import groupBy from 'lodash-es/groupBy';
import { sort_by_day, sort_by_time } from '@shared/helpers/sort';

export function groupByDay(items = []) {
  /**
   * Группируем по дню недели и возвращаем в формате
   * ['mon', [{start: '05:00:00', end: '06:00:00'}, {start: '02:00:00', end: '010:00:00'}]]
   */
  const days = Object.entries(groupBy(items, 'day'));
  const transform = days.map(([day, items]) => {
    /**
     * Временные отрезки сортируем и возврщаем в формате
     * { day: 'mon', items: [{start: '02:00:00', end: '10:00:00'}, {start: '05:00:00', end: '06:00:00'}] }
     */
    return {
      day: day,
      items: items.sort(sort_by_time)
    };
  });

  /**
   * Взвращаем массив отсортированный по дням недели Понедельник -> Воскресение
   */
  return transform.sort(sort_by_day);
}
